module.exports = __webpack_public_path__ + "static/img/16.45ddeca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/16.png
// module id = sRn+
// module chunks = 0